import i18next from "i18next";
import moment from "moment";
import "moment-timezone";
require("moment/min/locales.min");

const DEFAULT_DATE_TIME_FORMAT = "YYYY-MM-DD HH-mm-ss Z";
const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

export const getDateFormat = (includeTime) => {
  let format = includeTime ? DEFAULT_DATE_TIME_FORMAT : DEFAULT_DATE_FORMAT;
  const i18nFormatKey = includeTime
    ? "dataFormats.dateTimeFormat"
    : "dataFormats.dateFormat";
  if (i18next.exists(i18nFormatKey, { lng: i18next.language })) {
    format = i18next.t(i18nFormatKey, { lng: i18next.language });
  }
  return format;
};

export const getNumberFormats = () => {
  let thousandSeparator = ",";
  let decimalSeparator = ".";
  let thousandsGroupStyle = "thousand";
  if (
    i18next.exists("dataFormats.thousandSeparator", { lng: i18next.language })
  ) {
    thousandSeparator = i18next.t("dataFormats.thousandSeparator", {
      lng: i18next.language,
    });
  }
  if (
    i18next.exists("dataFormats.decimalSeparator", { lng: i18next.language })
  ) {
    decimalSeparator = i18next.t("dataFormats.decimalSeparator", {
      lng: i18next.language,
    });
  }
  if (
    i18next.exists("dataFormats.thousandsGroupStyle", { lng: i18next.language })
  ) {
    thousandsGroupStyle = i18next.t("dataFormats.thousandsGroupStyle", {
      lng: i18next.language,
    });
  }
  return {
    thousandSeparator,
    decimalSeparator,
    thousandsGroupStyle,
  };
};

export const formatDate = (value, includeTime) => {
  if (!value) {
    return "";
  }

  let format = includeTime ? DEFAULT_DATE_TIME_FORMAT : DEFAULT_DATE_FORMAT;
  const i18nFormatKey = includeTime
    ? "dataFormats.dateTimeFormat"
    : "dataFormats.dateFormat";
  if (
    i18next.exists(i18nFormatKey, {
      lng: i18next.language,
      fallbackLng: i18next.language,
    })
  ) {
    const i18nFormat = i18next.t(i18nFormatKey);
    if (!i18nFormat.includes('/')) {
      format = i18nFormat;
    }
    //format = i18next.t(i18nFormatKey);
  }

  var m = moment.tz(value, "Etc/GMT");
  m.locale(i18next.language);
  return m.format(format);
};

export const getGraphqlResult = (response, queryName) => {
  const { data = {} } = response || {};
  const results = data[queryName];
  if (!results) {
    throw new Error("error fetching records");
  }
  return results;
};

export const getAttribute = (attributes, id) => {
  const a = attributes.find((a) => {
    return a.id === id;
  });
  return a;
};

export const getAttributeValue = (attr) => {
  if (!attr) {
    return null;
  }
  if (attr.value !== null && attr.value !== undefined) {
    return attr.value;
  }
  if (attr.user_value !== null && attr.user_value !== undefined) {
    return attr.user_value;
  }
  if (attr.source_value !== undefined) {
    return attr.source_value;
  }
  return null;
};

export const getAttributeUnitValue = (attr) => {
  if (!attr) {
    return null;
  }
  if (attr.user_unit !== null && attr.user_unit !== undefined) {
    return attr.user_unit;
  }

  if (attr.source_unit !== null && attr.source_unit !== undefined) {
    return attr.source_unit;
  }
  return null;
};

export const getRandomColor = () => {
  const color =
    "rgb(" +
    [
      Math.round(Math.random() * 255),
      Math.round(Math.random() * 255),
      Math.round(Math.random() * 255),
    ].join(",") +
    ")";
  return color;
};

export const getEntityAddress = (addresses = []) => {
  if (addresses.length > 0) {
    let addr = addresses.find((a) => a.address_type === "REGISTERED");
    if (!addr) {
      addr = addresses.find((a) => a.address_type === "PRIMARY");
    }
    if (!addr) {
      addr = addresses.find((a) => a.address_type === "MAILING");
    }
    if (!addr) {
      addr = addresses[0];
    }
    return addr;
  }
};

const currencyUnit = {
  THOUSAND: 1000,
  MILLION: 1000000,
  BILLION: 1000000000,
  TRILLION: 1000000000000,
};

export const getFormattedCurrenyValue = (value) => {
  let amount = 0;

  if (typeof value === "string") {
    amount = Number(value);
  } else if (typeof value === "number") {
    amount = value;
  } else {
    return "";
  }

  for (let cu of Object.keys(currencyUnit)) {
    let res = amount / currencyUnit[cu];
    if (res <= 999 && 1 <= res) {
      return `${res} ${cu.toLowerCase()}`;
    }
  }

  return null;
};

export const validateEmail = (email) => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
};

export const validateJllEmail = (email) => {
  if (validateEmail(email)) {
    const domain = email.split("@").pop();
    if (domain.includes("jll.com") || domain.includes("tetris-db.com")) {
      return true;
    }
  }
  return false;
};
